import { ToastProvider } from "@/ds";
import styles from "./wizard-toast.module.scss";
import type { WizardToastProps, WizardToastViewModel } from "./types-wizard-toast";

/**
 * `ToastProvider` do DS do wizard Nova Obra: `useToast()` vale em toda a árvore. O toast renderiza no próprio dialog
 * (`appendTo`), não no canto da página. Sem o dialog (testes de etapa isolada) cai no `body` (o Prime, sem `appendTo`,
 * montaria inline).
 */
export function WizardToastView({
  children,
  appendTo,
  ancorado,
}: WizardToastProps & WizardToastViewModel) {
  return (
    <ToastProvider appendTo={appendTo} className={ancorado ? styles.noDialog : undefined}>
      {children}
    </ToastProvider>
  );
}
